
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "Form2",
    props: {
    totalScanCount: {
      type: String,
      default: "0",
    },
  },
  watch: {
    totalScanCount(newone, oldone) {
      this.TotalScanCount = newone;
    },
  },
})
export default class extends Vue {
  public TotalScanCount = "0";
}
